export function isEmptyObject(obj: object): boolean {
  return Object.keys(obj).length === 0;
}
